"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BrandsCtxItemDir_1 = require("./BrandsCtxItemDir");
var BrandsCtxItemDirNew_1 = require("./BrandsCtxItemDirNew");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var BrandsCtxAreaDir = /** @class */ (function (_super) {
    __extends(BrandsCtxAreaDir, _super);
    function BrandsCtxAreaDir(props) {
        return _super.call(this, props) || this;
    }
    BrandsCtxAreaDir.prototype.componentWillMount = function () {
        var _this = this;
        this.setState({
            dirList: this.props.data.getBrandItemById(this.props.brandId).directories
        });
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                dirList: _this.props.data.getBrandItemById(_this.props.brandId).directories
            });
        });
    };
    BrandsCtxAreaDir.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            dirList: nextProps.data.getBrandItemById(nextProps.brandId).directories
        });
    };
    BrandsCtxAreaDir.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BrandsCtxAreaDir.prototype.onSelectDirectoryClick = function (brandId, dirName) {
        if (this.props.onSelectDirectory) {
            this.props.onSelectDirectory(brandId, dirName);
        }
    };
    BrandsCtxAreaDir.prototype.deleteDirClick = function (brandId, dirName) {
        var _this = this;
        this.props.yesNoDlg
            .SetTitle("Удалить каталог ?")
            .SetMessage("\u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043A\u0430\u0442\u0430\u043B\u043E\u0433 " + dirName + " ?")
            .SetOnNoClick(function () { _this.props.yesNoDlg.Close(); })
            .SetOnYesClick(function () {
            _this.props.data.DeleteDirectory(_this.props.data.getBrandItemById(brandId), dirName, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041A\u0430\u0442\u0430\u043B\u043E\u0433 ",
                    React.createElement("b", null,
                        "[",
                        dirName,
                        "]"),
                    " \u0431\u044B\u043B \u0443\u0434\u0430\u043B\u0435\u043D"));
            });
        })
            .Show();
    };
    BrandsCtxAreaDir.prototype.editDirClick = function (brandId, dirName) {
        if (this.props.onEditDirectory) {
            this.props.onEditDirectory(brandId, dirName);
        }
    };
    BrandsCtxAreaDir.prototype.createDirClick = function (brandId) {
        if (this.props.onCreateDirectory) {
            this.props.onCreateDirectory(brandId);
        }
    };
    BrandsCtxAreaDir.prototype.getRenderObjectList = function () {
        var _ret = [];
        _ret.push(React.createElement(BrandsCtxItemDirNew_1.default, { title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C", brandId: this.props.brandId, key: "new-" + this.props.brandId + "-dir}", onNewClick: this.createDirClick.bind(this) }));
        for (var i = 0; i < this.state.dirList.length; i++) {
            _ret.push(React.createElement(BrandsCtxItemDir_1.default, { dirName: this.state.dirList[i].dirName, brandId: this.props.brandId, key: "dir-" + this.props.brandId + "-" + this.state.dirList[i].dirName, onDeleteClick: this.deleteDirClick.bind(this), onEditClick: this.editDirClick.bind(this), onSelectlick: this.onSelectDirectoryClick.bind(this), mode: "edit" }));
        }
        return _ret;
    };
    BrandsCtxAreaDir.prototype.render = function () {
        return (React.createElement("div", { style: {
                width: "100%",
                borderColor: "black",
                borderStyle: "solid",
                borderLeftWidth: "0px",
                borderTopWidth: "1px",
                borderRightWidth: "1px",
                borderBottomWidth: "1px",
                display: "flex",
                justifyContent: "flex-start",
                alignContent: "flex-start",
                alignItems: "flex-start",
                justifyItems: "flex-start",
                flexDirection: "row",
                flexWrap: "wrap",
                overflowY: "scroll",
                overflowX: "hidden"
            } }, this.getRenderObjectList()));
    };
    return BrandsCtxAreaDir;
}(React.Component));
exports.default = BrandsCtxAreaDir;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_images/ui/component/controls/BrandsCtxAreaDir.tsx
// module id = 2367
// module chunks = 0